import React from "react";
import { RainFormData, WizardEvidenceItem } from "../types";
import { RainDecisionRequest } from "../../../services/rainApi";
import JsonBlock from "../JsonBlock";

interface Props {
  form: RainFormData;
  evidence: WizardEvidenceItem[];
  payload: RainDecisionRequest;
}

const ReviewStep: React.FC<Props> = ({ form, evidence, payload }) => {
  const analyzed = evidence.filter((e) => e.status === "done");
  const failed = evidence.filter((e) => e.status === "failed");
  const validOptions = form.options.filter((o) => o.trim());

  return (
    <div className="rw-step">
      <h2 className="rw-step-title">Review &amp; submit</h2>
      <p className="rw-step-subtitle">
        The AI judge will research the question, weigh the evidence and pick
        one of the outcomes. This usually takes under a minute.
      </p>

      <div className="rw-review-block">
        <div className="rw-review-label">Question</div>
        <div className="rw-review-value">{form.question}</div>
      </div>

      <div className="rw-review-block">
        <div className="rw-review-label">Possible outcomes</div>
        <ol className="rw-review-options">
          {validOptions.map((option, i) => (
            <li key={i}>{option}</li>
          ))}
        </ol>
      </div>

      {form.context.trim() && (
        <div className="rw-review-block">
          <div className="rw-review-label">Background</div>
          <div className="rw-review-value rw-review-clamp">{form.context}</div>
        </div>
      )}

      {form.poolCreationDate && (
        <div className="rw-review-block">
          <div className="rw-review-label">Market creation date</div>
          <div className="rw-review-value">{form.poolCreationDate}</div>
        </div>
      )}

      {form.aiDecision.trim() && (
        <div className="rw-review-block">
          <div className="rw-review-label">Previous AI decision</div>
          <div className="rw-review-value rw-review-clamp">
            {form.aiDecision}
          </div>
        </div>
      )}

      <div className="rw-review-block">
        <div className="rw-review-label">Evidence</div>
        <div className="rw-review-value">
          {analyzed.length === 0
            ? "None - the judge will rely on its own research."
            : `${analyzed.length} analyzed item${
                analyzed.length > 1 ? "s" : ""
              } will be sent to the judge.`}
          {failed.length > 0 && (
            <span className="rw-review-warning">
              {" "}
              {failed.length} failed item{failed.length > 1 ? "s" : ""} will be
              left out.
            </span>
          )}
        </div>
      </div>

      <details className="rw-details">
        <summary>Developer view - exact request</summary>
        <p className="rw-hint">
          This is the request body that will be sent - the same shape the Rain
          backend sends in production.
        </p>
        <JsonBlock label="Request" value={payload} />
      </details>
    </div>
  );
};

export default ReviewStep;
